// --------------------------------------------------------
// CardEditPhoto - cardEditPhoto
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import { ContainerEditPhoto } from "./CardEditPhoto.styled";
import iconUpload from "../../assets/imgs/iconUploadPhoto.svg";
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// CardEditPhoto INTERFACE
// --------------------------------------------------------

interface IcardEditPhoto {
  htmlFor: string;
  text: string;
}
/**
/**
 * A component that renders a Component description here.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const CardEditPhoto = ({ text, htmlFor }: IcardEditPhoto) => {
  // --------------------------------------------------------
  // CardEditPhoto PRIVATE DECLARATIONS
  // --------------------------------------------------------

  // --------------------------------------------------------

  // --------------------------------------------------------
  // REACT RETURN FUNCTION
  // --------------------------------------------------------
  return (
    <ContainerEditPhoto htmlFor={htmlFor}>
      <img src={iconUpload} alt="" />
      {text}
    </ContainerEditPhoto>
  );
  // --------------------------------------------------------
};

export default CardEditPhoto;
